import { useEffect, useState } from "react"
import classNames from "classnames"

import { useLazyGetAlertStatusesWidgetQuery } from "store/api/alertsApi"
import { ApiTypes } from "types"

import { BarChart } from "components/common/BarChart"
import { Spinner } from "components/common/Spinner"
import { dummyAlertsStatusesWidgetData } from "pages/contractor/AlertsPage/dummyAlertsData"

import styles from "./index.module.scss"

interface AlertStatusesWidgetProps {
  hasAlertsAccess: boolean
  updateIndex: number
}

const initialWidgetStatusesData: ApiTypes.Res.AlertStatusesWidget = {
  active: 0,
  frozen: 0,
  acknowledged: 0,
}

export const WidgetAlertStatuses = ({ hasAlertsAccess, updateIndex }: AlertStatusesWidgetProps) => {
  const [widgetData, setWidgetData] = useState(initialWidgetStatusesData)
  const [triggerGetAlertStatusesWidget, { isFetching }] = useLazyGetAlertStatusesWidgetQuery()

  useEffect(() => {
    if (!hasAlertsAccess) {
      setWidgetData(dummyAlertsStatusesWidgetData)
      return
    }

    const fetchData = async () => {
      try {
        const res = await triggerGetAlertStatusesWidget()
        if (res?.data) {
          setWidgetData({
            active: res?.data?.data?.active,
            frozen: res?.data?.data?.frozen,
            acknowledged: res?.data?.data?.acknowledged,
          })
        }
      } catch (error) {
        console.error(error)
      }
    }

    fetchData()
  }, [hasAlertsAccess, updateIndex])

  return (
    <div className={classNames(styles.alertsWidgetWrapper)}>
      <header className={styles.widgetHeader}>
        <h3 className={styles.widgetTitle}>Alerts Statuses</h3>
      </header>
      <div className={styles.chartWrapper}>
        <BarChart
          items={[
            {
              color: "#22C55E",
              value: widgetData.active,
            },
            {
              color: "#475569",
              value: widgetData.frozen,
            },
            {
              color: "#2DB2C8",
              value: widgetData.acknowledged,
            },
          ]}
        />
        <div className={styles.indicatorsWrapper}>
          <span className={styles.indicator}>
            <i
              className={styles.colorCircle}
              style={{
                backgroundColor: "#22C55E",
              }}
            />
            Active
            <i>{widgetData.active}</i>
          </span>
          <span className={styles.indicator}>
            <i
              className={styles.colorCircle}
              style={{
                backgroundColor: "#475569",
              }}
            />
            Frozen
            <i>{widgetData.frozen}</i>
          </span>
          <span className={styles.indicator}>
            <i
              className={styles.colorCircle}
              style={{
                backgroundColor: "#2DB2C8",
              }}
            />
            Acknowledged
            <i>{widgetData.acknowledged}</i>
          </span>
        </div>
        {isFetching && (
          <div className={styles.widgetLoader}>
            <Spinner />
          </div>
        )}
      </div>
    </div>
  )
}
